import {
    setCustomValidator,
    Validator,
    FieldContent,
    ExtendedErrorId,
    getRefByFieldId,
    ExtendedFieldId,
    FieldId,
} from '@sheerid/jslib';


export const addConfirmEmailValidator = () => {
    const confirmEmailFieldId: ExtendedFieldId = 'confirm-email';
    const emailFieldId: FieldId = 'email';

    const getConfirmEmailValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        const invalidError: ExtendedErrorId = 'invalidConfirmEmail';
        const nonMatchEmail: ExtendedErrorId = 'nonMatchEmail';
        const emailValue = (getRefByFieldId(emailFieldId) as HTMLInputElement) ? (getRefByFieldId(emailFieldId) as HTMLInputElement).value : '';

        if (value !== emailValue) {
            return nonMatchEmail;
        }
        if (value.length <= 0) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(confirmEmailFieldId, getConfirmEmailValidationError);
};

export const addCourseTypeValidator = () => {
    const courseTypeFieldId = 'course-type';

    const getCourseTypeValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        const invalidError: ExtendedErrorId = 'invalidCourseType';

        if (!value) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(courseTypeFieldId, getCourseTypeValidationError);
};

export const addQuickBooksDesktopVersionValidator = () => {
    const quickBooksDesktopVersionFieldId = 'desktop-year';

    const getQuickBooksDesktopVersionValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        const invalidError: ExtendedErrorId = 'invalidQuickBooksDesktopVersion';

        if (!value) {
            return invalidError;
        }
        return;
    };
    setCustomValidator(quickBooksDesktopVersionFieldId, getQuickBooksDesktopVersionValidationError);
};
